import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-modification-telephone-credit',
  templateUrl: './modification-telephone-credit.component.html',
  standalone: false,
})
export class ModificationTelephoneCreditComponent {
  @Input() formGroup!: FormGroup;
}
